<div *ngIf="paginatedData && paginatedData.length">
    <div>
      <table class="bz-table">
        <thead>
          <tr>
            <th class="bz-table__cell bmc-sync-data__td-left">
              {{'SYNC_FILES.FILENAME' | translate}}
            </th>
            <th class="bz-table__cell bmc-sync-data__td-left">
              {{'SYNC_FILES.TIMESTAMP' | translate}}
            </th>
            <th class="bz-table__cell bmc-sync-data__td-left">
              {{'SYNC_FILES.STATUS' | translate}}
            </th>
            <th class="bz-table__cell bmc-sync-data__td-center">
              {{'SYNC_FILES.DOWNLOAD' | translate}}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of paginatedData; let index=index; let even=even">
          <tr (click)="item.detailExpanded = !item.detailExpanded" class="toogle_action"
          [ngClass]="{'dark': index % 2 === 0, 'light': index % 2 === 1}" >
            <td class="bz-table__cell fileName">
              <svg class="bz-icon-svg--16 bz-icn" *ngIf="item.errorLog&&item.showDetail&&item.detailExpanded">
                <use xlink:href="#arrow-up" />
              </svg>
              <svg class="bz-icon-svg--16 bz-icn" *ngIf="item.errorLog&&item.showDetail&&!item.detailExpanded">
                <use xlink:href="#arrow-down" />
              </svg>
              {{item.fileName}}
            </td>
            <td class="bz-table__cell timestamp">
              {{ item.timestamp | userTimezoneFormat:1 }}
            </td>
            <td class="bz-table__cell status" [ngSwitch]="item.status">
              <div *ngSwitchCase="'Created'">
                <bzg-icon [nameIcon]="'icon-info-strong'" [color]="'info'"></bzg-icon>
              </div>
              <div *ngSwitchCase="'InProgress'">
                <bzg-icon [nameIcon]="'icon-info-strong'" [color]="'info'"></bzg-icon>
              </div>
              <div *ngSwitchCase="'Error'">
                <bzg-icon [nameIcon]="'icon-error'" [color]="'error'" [bzgTooltip]="item.errorLog"
                  bzgTooltipPosition="above"></bzg-icon>
              </div>
              <div *ngSwitchCase="'Done'">
                <bzg-icon [nameIcon]="'icon-check-mark'" [color]="'success'"></bzg-icon>
              </div>
            </td>
            <td class="bz-table__cell bmc-sync-files__td-center  download">
              <bz-loading [size]="'s'" *ngIf="item.status === 'Created' || item.status === 'InProgress'">
              </bz-loading>
              <a (click)="onDownloadFile(item.rowKey, item.fileName)" *ngIf="item.status === 'Done'">
                <bzg-icon [nameIcon]="'icon-download'" [color]="'active'">
                </bzg-icon>
              </a>
            </td>
          </tr>
          <tr class="tid-detail-row" *ngIf="item.errorLog"
          [ngClass]="{'show': item.detailExpanded}">
            <td colspan="4">
              <div class="detail_content">
                <biz-sync-files-error-table [errorData]="getFilesWithError(item,item.errorLog)" [status]="import" [showLog]="true"></biz-sync-files-error-table>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <a #fileLink id="fileLink" style="visibility:hidden"></a>
    </div>
    <div class="bz-table-pagination">
      <bzg-paginator [pageSize]="pageSize" [totalItems]="_history ? _history.length : 10"
        (paginationChanged)="onPaginationEvent($event)" [pageSizeOptions]="[5,10]">
      </bzg-paginator>
    </div>
  </div>
